import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import paymentComponent from "../../components/DefaultPaymentComponent.vue";
import { createRejectError, makePurchase, PAYMENT_ERROR_MESSAGES, TIMEOUT_TO_CLOSE } from "../../integrations/utils";
import { IntegrationModule } from "../types";

const getUrl = async (getOriginUrl: () => Promise<string>) => {
  const response = await getOriginUrl();
  const aliJapanUrl = new URL(response);
  const aliJapanResultUrl = encodeURIComponent(aliJapanUrl.origin + aliJapanUrl.pathname);
  const payPageUrl = new URL("/payments/alijapan/pay.html", location.origin);

  payPageUrl.searchParams.append("host", aliJapanResultUrl);
  for (const [key, value] of aliJapanUrl.searchParams) {
    payPageUrl.searchParams.append(key, encodeURIComponent(value));
  }

  return payPageUrl.toString();
};

const integrationModule: IntegrationModule<never> = {
  paymentComponent,
  purchase: data =>
    new Promise(async (resolve, reject) => {
      try {
        let timeout: ReturnType<typeof setTimeout>;
        const subscription = await providers.PaymentSystemsProvider.subscribeDepositPurchase(t => {
          timeout && clearTimeout(timeout);
          subscription.unsubscribe();
          resolve({
            status: true,
            subjectPurchased: false,
            transaction: t,
          });
        });
        try {
          await makePurchase(() => getUrl(() => providers.AliJapanPurchaseProvider.getDepositUrl({ data }))).catch(
            e => {
              if (e.message === PAYMENT_ERROR_MESSAGES.VERIFY_TRANSACTION) {
                timeout = setTimeout(() => {
                  subscription.unsubscribe();
                  reject(createRejectError(e));
                }, TIMEOUT_TO_CLOSE);
              } else throw e;
            }
          );
        } catch (e) {
          subscription.unsubscribe();
          reject(createRejectError(e));
        }
      } catch (e) {
        reject(createRejectError(e));
      }
    }),
  subscribe: data =>
    new Promise(async (resolve, reject) => {
      try {
        let timeout: ReturnType<typeof setTimeout>;
        const subscription = await providers.PaymentSystemsProvider.subscribeRecurringPurchase(s => {
          timeout && clearTimeout(timeout);
          subscription.unsubscribe();
          resolve({
            status: true,
            subjectPurchased: false,
            subscription: s,
          });
        });
        try {
          await makePurchase(() => getUrl(() => providers.AliJapanPurchaseProvider.getRecurringUrl({ data }))).catch(
            e => {
              if (e.message === PAYMENT_ERROR_MESSAGES.VERIFY_TRANSACTION) {
                timeout = setTimeout(() => {
                  subscription.unsubscribe();
                  reject(createRejectError(e));
                }, TIMEOUT_TO_CLOSE);
              } else throw e;
            }
          );
        } catch (e) {
          subscription.unsubscribe();
          reject(createRejectError(e));
        }
      } catch (e) {
        reject(createRejectError(e));
      }
    }),
  allowSaveCard: false,
  name: $t("AliJapan"),
  logo: "/img/paymentSystems/alij.jpg",
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "alijapan" ?? false;
};

export default integrationModule;
